export default __webpack_public_path__ + "static/media/globe.95070c34.png";